/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorNaryLogic extends models.QueryOperatorNary {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorNaryLogic");
    }

    getFixupPrototypeFunction() { return QueryOperatorNaryLogic.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorNaryLogic>): QueryOperatorNaryLogic {
        let obj = Object.assign(new QueryOperatorNaryLogic(), model);
        QueryOperatorNaryLogic.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorNaryLogic>): QueryOperatorNaryLogic {
        if (!model) return null;
        return QueryOperatorNaryLogic.newInstance(<QueryOperatorNaryLogic> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorNaryLogic) {
        if (!obj) return;

        models.QueryOperatorNaryLogic.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorNaryLogic): boolean {
        if (models.QueryOperatorNary.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorNaryLogic.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of n-ary operation
     */
    op: models.ResourceNaryQueryCondition;

}
